/**
 * Sentinel value for the school-class filter.
 *
 * Meaning of the `teamId` filter values used across `listChildren` and the
 * `SchoolClassSelect` component:
 * - `null` / `undefined` → no filter ("Semua" / all classes)
 * - `NO_SCHOOL_CLASS_ID` → children that are not assigned to any class ("Tanpa kelas")
 * - any other string     → a specific class (team) id
 */
export const NO_SCHOOL_CLASS_ID = '__no_class__'

/**
 * Sentinel `groups[].key` for the unassigned bucket in
 * `schoolDashboard.getLessonEngagementByGroup` — students with no team ("Tanpa kelas") or no
 * `user.schoolClass` value ("Tanpa tingkat"). There is no real id to key those rows by.
 */
export const NO_GROUP_KEY = '__none__'

/**
 * How many Premium students a school needs before its teachers may open premium books.
 *
 * The old rule was "the organization holds at least one live seat", which a single seat satisfied —
 * so one seat bought for one child unlocked the whole staff room. Premium reading for adults is a
 * benefit of a school that has actually adopted Premium, so the gate counts students instead.
 *
 * Counted with `countPremiumCapacity`: every live seat the school owns, handed out or not, plus its
 * students seated by ANY other source — a parent's own family subscription included. A school does
 * not have to be the one paying, and it does not have to finish assigning its seats first.
 */
export const TEACHER_READING_MIN_PREMIUM_STUDENTS = 8

/**
 * How many Premium students a school needs before the school dashboard opens.
 *
 * Deliberately far above {@link TEACHER_READING_MIN_PREMIUM_STUDENTS}: the dashboard is school-wide
 * analytics, and per-class trends and "students needing attention" only say anything once a real
 * share of the school is on Premium. Below this the charts read as noise.
 *
 * Counted the same way — see the note on {@link TEACHER_READING_MIN_PREMIUM_STUDENTS}.
 */
export const SCHOOL_DASHBOARD_MIN_PREMIUM_STUDENTS = 50
